import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formId", "tab", "href", "children"];
import Log from 'forms-utils-lib/logger/Logger';
import { getSubmissionsToSubmissionsAppUrl } from 'FormsUI/lib/RouteGenerators';
import getSubmissionsUrl from 'FormsUI/utils/url/getSubmissionsUrl';
import AppLink from 'FormsUI/components/common/AppLink';
import { jsx as _jsx } from "react/jsx-runtime";
const getAppLinkHref = ({
  href,
  formId,
  tab
}) => {
  if (href) {
    return getSubmissionsToSubmissionsAppUrl(href);
  } else if (formId) {
    return getSubmissionsUrl(formId, tab);
  } else {
    Log.error(`Could not build submissions url, href or formId not provided.`);
    return '';
  }
};
export const SubmissionsAppLink = _ref => {
  let {
      formId,
      tab,
      href,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const appLinkHref = getAppLinkHref({
    href,
    formId,
    tab
  });
  const referer = window.location.href;
  const url = `${appLinkHref}?redirectUrl=${encodeURIComponent(referer)}`;
  return /*#__PURE__*/_jsx(AppLink, Object.assign({}, rest, {
    href: url,
    children: children
  }));
};
export default SubmissionsAppLink;